import { TokenStorageService } from './../../../../@core/services/token-storage.service';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ApiService } from '@core/services/api.service';
import { CoreConfigService } from '@core/services/config.service';
import { Settings } from '@core/types/settings';

@Component({
  selector: 'app-all-pages',
  templateUrl: './all-pages.component.html',
  styleUrls: ['./all-pages.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AllPagesComponent implements OnInit {

  public contentHeader: object;
  public user: any
  public data: any
  public pages: any = []
  page_details: any

  public siteSettings: Settings;

  constructor(
    private tokenStorage: TokenStorageService,
    private _coreConfigService: CoreConfigService,
    private api: ApiService
  ) {

    this.api.post('dashboard', {}).subscribe((response: any) => {
      this.data = response; 
    });

    this.api.externalGet('fetch-all-pages').subscribe((response: any) => {
      this.pages = response.data; 
    });

    // content header
    this.contentHeader = {
      headerTitle: 'More Pages',
      actionButton: false,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Home',
            isLink: true,
            link: '/dashboard'
          },
          {
            name: 'More Pages',
            isLink: false
          }
        ]
      }
    };
    
  }

  toTitleCase(value: string): string {
    if (!value) return value;

    return value.replace(/\b\w/g, (match) => match.toUpperCase());
  }

  pageDetails(page) {
    this.page_details = page
  }

  ngOnInit() {

    if (this.tokenStorage.getToken()) {
      this.user = this.tokenStorage.getUser();
    }

    this._coreConfigService.sysConfig().subscribe(config => {
      // console.log("site settings: ", config)
      this.siteSettings = config.data;
    });

    
  }

}
